/* eslint-disable max-len */
export default {
  getPrice: (state) => (itemCode) => (state.pricings?.find((p) => p.itemCode === itemCode)?.price ?? 0),
  pricingCount: (state) => (state.pricings?.length ?? 0),
};
